import { Array as A } from 'effect';

import type { JeHeadersConfig, SwapCellsPayload } from '@/domain/jeFieldRearrangement/types';

export type ConfigEdit = (config: JeHeadersConfig) => JeHeadersConfig;

export const EMPTY_CONFIG: JeHeadersConfig = { positions: {}, hidden: [], shown: [], locked: [] };

const withoutField = (list: ReadonlyArray<string>, fieldName: string) => A.filter(list, (f) => f !== fieldName);

const withoutFields = (list: ReadonlyArray<string>, fieldNames: ReadonlyArray<string>) =>
  A.filter(list, (f) => !fieldNames.includes(f));

export const swapCells =
  ({ fieldNameA, pairIdA, fieldNameB, pairIdB }: SwapCellsPayload): ConfigEdit =>
  (config) =>
    !fieldNameA || !pairIdA || !pairIdB || pairIdA === pairIdB
      ? config
      : {
          ...config,
          positions: {
            ...config.positions,
            [fieldNameA]: pairIdB,
            ...(fieldNameB ? { [fieldNameB]: pairIdA } : {}),
          },
        };

/**
 * `aliases` are the field's other names its settings may be stored under (its description name, DA-18808).
 * Hide and show clear the opposite setting under every name, so an older entry under another name cannot keep
 * the field hidden or shown.
 */
export const hideCell =
  (fieldName: string, aliases: ReadonlyArray<string> = []): ConfigEdit =>
  (config) =>
    !fieldName
      ? config
      : {
          ...config,
          hidden: [...withoutField(config.hidden, fieldName), fieldName],
          shown: withoutFields(config.shown, [fieldName, ...aliases]),
        };

export const showCell =
  (fieldName: string, aliases: ReadonlyArray<string> = []): ConfigEdit =>
  (config) =>
    !fieldName
      ? config
      : {
          ...config,
          shown: [...withoutField(config.shown, fieldName), fieldName],
          hidden: withoutFields(config.hidden, [fieldName, ...aliases]),
        };

export const resetConfig: ConfigEdit = (config) => ({ ...config, ...EMPTY_CONFIG });
